import { Module } from '../module/models';
import { ResourceCategory } from '../resource/models';
import { IDeserializable } from '../shared/models/deserializable';
export class Spinner {
  showSpinner: boolean;
}
export class Course extends Spinner implements IDeserializable {
  Id: number;
  Name: string;
  Description: string;
  EstimatedTotalLength: number;
  Modules: Module[];
  PercentCompleted: number;
  Status: number;
  UserHasALicense: boolean;
  Image: string;
  UserHasCertificate: boolean;
  ProgramAccessTypeId: number;
  LicenseText: string;
  ShowPercentageComplete: boolean;
  Discount: Discount;
  IsTeacherDemo: boolean;
  CourseAuthors: CourseAuthor[];

  deserialize(obj: any) {
    Object.assign(this, obj);
    // this.Discount = obj && obj.Discount && new Discount().deserialize(obj.Discount);
    return this;
  }
}

export class Discount implements IDeserializable {
  Description: string;
  Name: string;
  Eligible: boolean;

  deserialize(obj: any) {
    Object.assign(this, obj);
    return this;
  }
}

export class CourseResources {
  Id: number;
  CourseName: string;
  CourseResourcesCategories: ResourceCategory[];

  constructor(obj?: any) {
    this.Id = (obj && obj.Id) || 0;
    this.CourseName = (obj && obj.CourseName) || '';
    this.CourseResourcesCategories =
      (obj &&
        obj.CourseResourcesCategories &&
        obj.CourseResourcesCategories.map(t => t as ResourceCategory[])) ||
      new Array<ResourceCategory>();
  }
}

export class CourseAuthor {
  Id: number;
  AuthorName: string;
}

export class Note {
  NotesId: number;
  LessonAssignmentId: number;
  Text: string;

  constructor(obj?: any) {
    this.NotesId = (obj && obj.NotesId) || 0;
    this.LessonAssignmentId = (obj && obj.LessonAssignmentId) || 0;
    this.Text = (obj && obj.Text) || null;
  }
}

export class NoteMessage {
  Show: boolean;
  Text: string;
  Status: number;
}
